var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("Recent User Logins")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.results},scopedSlots:_vm._u([{key:"cell(date_created)",fn:function(data){return [_vm._v(" "+_vm._s(_vm._f("fullDate")(data.value))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }